<script>
  export let value;
 export let name;

 export let checked;
 export let aftags = [];

  function handleClick() {
    console.log(`handle click -${checked} -${aftags}`, aftags);
    if (!Array.isArray(aftags)) {
      aftags = [];
    }
    // this runs before value is set
    if (!checked) {
      if (!aftags.includes(value)) {
        aftags.push(value);
      }
    } else if (aftags.includes(value)) {
      aftags.splice(aftags.indexOf(value), 1);
    }
  }
 
 if (!Array.isArray(aftags)) {
     aftags = [];
 }
 
 checked = aftags.includes(value)

</script>
<style>
  .ck-button {
    margin: 4px 0px 4px 4px;
    border-radius: 16px;
    border: 1px solid #ccc;
    float: left;
    background: #f6f3eb;
    overflow: visible;
    padding: 2px 4px 0 4px;
  }

  .ck-button:hover {
    overflow: auto;
    float: left;
    background: #ffb718;
    /* background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#f4d181),
      to(#e78f2e)
    );
    background: -moz-linear-gradient(top, #f4d181, #e78f2e);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4d181', endColorstr='#e78f2e'); */
    color: #fff;
  }

  .ck-button.selected {
    overflow: auto;
    float: left;
    background-color: #e78f2e;
    /* background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#e78f2e),
      to(#f4d181)
    );
    background: -moz-linear-gradient(top, #e78f2e, #f4d181);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e78f2e', endColorstr='#f4d181'); */
    color: #fff;
  }

  .ck-button label {
    overflow: visible;
    float: left;
  }

  .ck-button label span {
    text-align: center;
    padding: 4px 4px 0px 4px;
    display: block;
    font-size: 12px;
    font-weight: normal;
    overflow: visible;
  }

  .ck-button label input {
    position: absolute;
    top: -2000px;
  }

  .ck-button input:checked {
    background-color: #999;
  }
</style>
<div class="ck-button {checked ? 'selected' : ''}">
				<label>
					<input bind:checked={checked} 
          type="checkbox" 
          name="{name}" 
          bind:value={value}
          on:click={handleClick}
          />
					<span>{@html value} </span>
				</label>
</div>
